import { render, staticRenderFns } from "./VideoMonitor.vue?vue&type=template&id=5ca8df1b&scoped=true&"
import script from "./VideoMonitor.vue?vue&type=script&lang=js&"
export * from "./VideoMonitor.vue?vue&type=script&lang=js&"
import style0 from "./VideoMonitor.vue?vue&type=style&index=0&id=5ca8df1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca8df1b",
  null
  
)

export default component.exports